import React from 'react';
import ConfigPanel from '../components/ConfigPanel';

const ConfigPage: React.FC = () => {
  return (
    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <ConfigPanel />
    </div>
  );
};

export default ConfigPage;
